import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import { useEffect, useState } from 'react';
import UITable from 'UIComponents/table/UITable';
import { H5 } from 'UIComponents/elements/headings';
import UISearchInput from 'UIComponents/input/UISearchInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SortRecordsButton, { OPTIONS } from 'automation-ui-canvas/containers/flow-views/test-flow/SortRecordsButton';
import { CRM_SEARCH_FIELD_NAME, CRM_SEARCH } from 'automation-ui-management/queries/crmObjectQueries';
import { useQuery } from 'data-fetching-client';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import UIButton from 'UIComponents/button/UIButton';
import { useGetSearchableFilterOptions } from 'automation-ui-log-events/hooks/crmSearchHooks';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import { useHistory } from 'react-router-dom';
import { atomicQueryUpdate } from 'automation-ui-routing/historyUtils';
import { RECORD_ID_QUERY_PARAM } from 'automation-ui-canvas/containers/flow-views/test-flow/constants';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { View } from 'foundations-components/transitional/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PAGE_SIZE = 25;
const TestFlowViewSelectRecordPanelV2 = ({
  flow,
  objectTypeDefinition
}) => {
  var _objectTypeDefinition;
  const history = useHistory();
  const {
    getSearchableFilterOptions
  } = useGetSearchableFilterOptions(flow.objectTypeId);
  const trackEvent = useTrackEvent();
  const [sort, setSort] = useState(OPTIONS[0]);
  const [query, setQuery] = useState({
    objectTypeId: flow.objectTypeId,
    count: PAGE_SIZE,
    offset: 0,
    sorts: sort.getSorts(objectTypeDefinition.primaryDisplayLabelPropertyName, (_objectTypeDefinition = objectTypeDefinition.secondaryDisplayLabelPropertyNames) !== null && _objectTypeDefinition !== void 0 ? _objectTypeDefinition : undefined)
  });
  const {
    data
  } = useQuery(CRM_SEARCH, {
    variables: {
      crmSearchOptions: query
    }
  });
  const searchResponse = data === null || data === void 0 ? void 0 : data[CRM_SEARCH_FIELD_NAME];
  const results = searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.results;
  const [allObjects, setAllObjects] = useState([]);
  useEffect(() => {
    const newResults = searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.results;
    if (newResults) {
      setAllObjects(prevResults => (prevResults !== null && prevResults !== void 0 ? prevResults : []).concat(newResults));
    }
  }, [searchResponse]);
  return /*#__PURE__*/_jsxs(UIPanelBody, {
    children: [/*#__PURE__*/_jsxs(View, {
      padding: "500",
      backgroundColor: "fill-surface-raised",
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.testV2.chooseRecordPanel.prompt"
        })
      }), /*#__PURE__*/_jsx(UISearchInput, {
        use: "on-dark",
        onChange: ({
          target: {
            value
          }
        }) => {
          setAllObjects([]);
          setQuery(prev => Object.assign({}, prev, {
            offset: 0
          }, getSearchableFilterOptions(value || '')));
        }
      }), /*#__PURE__*/_jsx(SortRecordsButton, {
        value: sort.id,
        onChange: option => {
          setSort(option);
          setAllObjects([]);
          setQuery(prev => {
            var _objectTypeDefinition2;
            return Object.assign({}, prev, {
              offset: 0,
              sorts: option.getSorts(objectTypeDefinition.primaryDisplayLabelPropertyName, (_objectTypeDefinition2 = objectTypeDefinition.secondaryDisplayLabelPropertyNames) !== null && _objectTypeDefinition2 !== void 0 ? _objectTypeDefinition2 : undefined)
            });
          });
        }
      })]
    }), /*#__PURE__*/_jsx(UITable, {
      condensed: true,
      responsiveWrapperClassName: "m-bottom-0",
      children: /*#__PURE__*/_jsx("tbody", {
        children: allObjects && allObjects.map(reference => {
          return /*#__PURE__*/_jsx("tr", {
            children: /*#__PURE__*/_jsx(UITableHoverCell, {
              hoverContent: /*#__PURE__*/_jsx("span", {
                children: /*#__PURE__*/_jsx(UIButton, {
                  onClick: () => {
                    trackEvent(Trackables.CLICK_TEST_FLOW_RECORD);
                    atomicQueryUpdate({
                      [RECORD_ID_QUERY_PARAM]: reference.objectId
                    }, [], history);
                  },
                  responsive: false,
                  size: "extra-small",
                  use: "tertiary-light",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "automation.testV2.chooseRecordPanel.choose"
                  })
                })
              }),
              children: /*#__PURE__*/_jsx(ObjectNameReference, {
                objectTypeId: flow.objectTypeId,
                id: reference.objectId
              })
            })
          }, reference.objectId);
        })
      })
    }), searchResponse && searchResponse.hasMore && /*#__PURE__*/_jsx(TFlex, {
      justify: "center",
      paddingBlock: "500",
      children: /*#__PURE__*/_jsx(UIButton, {
        onClick: () => {
          setQuery(prev => Object.assign({}, prev, {
            offset: prev.offset + PAGE_SIZE,
            count: PAGE_SIZE
          }));
        },
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.testV2.chooseRecordPanel.loadMore"
        })
      })
    })]
  });
};
export default TestFlowViewSelectRecordPanelV2;